import { createRoute } from "@tanstack/react-router";
import { appRoute } from "../shell/routes";
import { ApprovalsPage } from "./ApprovalsPage";

/** `/approvals` belongs to the person, not a workspace; push notifications link here. */
export const approvalsRoute = createRoute({ getParentRoute: () => appRoute, path: "approvals", component: ApprovalsPage });
